import { type UseQueryResult, useQuery } from 'react-query';
import {
  CompanyFeatureService,
  // eslint-disable-next-line camelcase
  type OptionDto_Guid,
} from '@wealthlane/api-services/wealthlane-identity-service';

const useGetCompanyFeatureSet = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  OptionDto_Guid[] | undefined,
  unknown
> => {
  const companyFeatureSet = useQuery(['getCompanyFeatureSet'], async () => {
    if (id) {
      return await handleRequest(CompanyFeatureService.getApiIdentityCompanyFeatureSet(id));
    }
  });

  return companyFeatureSet;
};

export default useGetCompanyFeatureSet;
